use '@use-gpu/wgsl/use/types'::{ SurfaceFragment };
use '@use-gpu/wgsl/use/view'::{ getViewPosition };
use '@use-gpu/wgsl/fragment/pbr'::{ fresnelSchlick };

@link fn getSurface(
  color: vec4<f32>,
  uv: vec4<f32>,
  st: vec4<f32>,
  normal: vec4<f32>,
  tangent: vec4<f32>,
  position: vec4<f32>,
  coord: vec4<f32>,
) -> SurfaceFragment {};

@optional @link fn getOpacity() -> f32 { return 0.0; };

@export fn getFresnelEffectSurface(
  color: vec4<f32>,
  uv: vec4<f32>,
  st: vec4<f32>,
  normal: vec4<f32>,
  tangent: vec4<f32>,
  position: vec4<f32>,
  coord: vec4<f32>,
) -> SurfaceFragment {
  var surface = getSurface(color, uv, st, normal, tangent, position, coord);

  let viewPosition = getViewPosition();
  let surfacePosition = surface.position.xyz;
  let toView = viewPosition.xyz - surfacePosition * viewPosition.w;

  let N: vec3<f32> = normalize(surface.normal.xyz);
  let V: vec3<f32> = normalize(toView);

  let opacity = getOpacity();

  let cosTheta = clamp(dot(N, V), 0.0, 1.0);
  let f = fresnelSchlick(cosTheta, opacity, 1.0);

  surface.albedo.a = surface.albedo.a * f;

  return surface;
}
